




























import { Component, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import vSelect from 'vue-select';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import addBilling from '@/components/add business objects/addBilling.vue';
import { Org, OrgsApi } from '../../../api';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);
@Component({
	components: {
		secondaryNav,
		vSelect,
		addBilling,
	},
	validations: {},
	mixins: [validationMixin],
})
export default class OrgUpdate extends Vue {
	public accountApprovedOptions = [
		{ value: 0, text: 'Not Approved' },
		{ value: 1, text: 'Approved' },
	];

	public org: any = null;

	public $bvToast: any;
	public loading = true;
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	private api: OrgsApi;

	constructor() {
		super();
		this.api = new OrgsApi();
	}

	public async load() {
		const { orgId } = this.$route.params;
		this.submitStatus = 'OK';
		this.loading = true;

		try {
			const response = await this.api.getOrgById(parseInt(orgId, 10), ['admin', 'subscription'], {
				params: {
					'fields[admin]': 'id,name',
				},
			});

			this.org = response.data;
		} catch (e) {
			console.log(e);
			this.org = null;
		} finally {
			this.loading = false;
		}
	}

	public created() {
		this.load();
	}
}
